import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfCategory, ModelOfEspecie, ModelOfFuelType, ModelOfUnity, ModelOfVehicleItem } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';
import { ModelOfAbastecimento } from 'src/modelreport/relabastecimento';


export const useListFuelController = () => {
    const [loading, setLoading] = useState(true);
    const { userAgencyId } = useAuth();
    const toast: any = useRef();
    const [abastecimentos, setAbastecimentos] = useState<ModelOfAbastecimento[]>([]);
    const [UnitysData, setUnitysData] = useState<ModelOfUnity[]>([]);
    const [vehicleList, setVehicleList] = useState<ModelOfVehicleItem[]>([]);
    const [postosList, setPostosList] = useState<{ ID: string; NOME: string }[]>([]);

    const motaAbastecimento = (tipoCombustivel: ModelOfFuelType | null, categoria: ModelOfCategory | null,
        especie: ModelOfEspecie | null, dataInicio: string | undefined, dataFim: string | undefined,
        idUnity: string | undefined,
        idVeiculo: string | undefined,
        idCredor?: string) => {
        setLoading(true);

        api.post('abastecimentos/', {
            idTipoCombustivel: tipoCombustivel?.ID,
            idCategoria: categoria?.ID,
            idEspecie: especie?.ID,
            idOrgao: userAgencyId,
            dataInicio: dataInicio,
            dataFim: dataFim,
            idUnity: idUnity,
            idVeiculo: idVeiculo,
            idCredor: idCredor,
        }
        )
            .then(response => {
                const data = response.data;
                //console.log("data: ", data)
                setAbastecimentos(data);
                setLoading(false);
            })
            .catch((response: AxiosResponse) => {
                console.log('erro: ', response.status);
                setLoading(false);
            });
    };

    const getAllUnitys = () => {
        //necessario refatorar com o ROW, enviar ROW.
        api.post('agencys/all-unitys', { ORGAO: userAgencyId })
            .then(response => {
                const data = response.data;

                console.log("   ---> ", data);

                setUnitysData(data);
                setLoading(false);
            })
            .catch((response: AxiosResponse) => {
                console.log('erro: ', response.status);
                setLoading(false);
            });
    };

    useEffect(() => {
        getAllUnitys();
        getVehicleOrgaoList();
        getPostos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAgencyId]);

    const vehicles = vehicleList.map(vehicle => {
        return { label: vehicle.PLACA + " | " + vehicle.DESCRICAO, value: vehicle.ID };
    });

    const postos = postosList.map(p => ({ label: p.NOME, value: p.ID }));

    const getVehicleOrgaoList = async () => {
        console.log("userAgencyId: ", userAgencyId)
        const response = await api.post('/listVehiclesByOrgao', {
            ORGAO: userAgencyId,
        });
        setVehicleList(response.data);
    };

    const getPostos = async () => {
        if (!userAgencyId) return;
        const response = await api.get(`/postos/${userAgencyId}`);
        setPostosList(response.data || []);
    };



    return {
        getAbastecimentoController: {
            loading,
            toast,
            abastecimentos,
            UnitysData,
            vehicles,
            postos,
        },
        handleAbastecimentoController: {
            setLoading,
            motaAbastecimento,
            setAbastecimentos,
        },
    };


}



